import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 21 20"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.5 18.335a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667M11.37 6H9.62l.058 5.635h1.645zm-1.937 7.234c0 .583.467 1.05 1.062 1.05.606 0 1.073-.467 1.073-1.05 0-.584-.467-1.039-1.073-1.039-.595 0-1.062.455-1.062 1.039",
      clipRule: "evenodd"
    }
  )
);
var SvgWarningCircleFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var WarningCircleFilled_default = SvgWarningCircleFilled;

export { WarningCircleFilled_default as default };
